import styled from 'styled-components';
import { Colors } from '@/common/colors/colors';

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const Label = styled.label`
	color: ${Colors.darkBlue};
	font-size: 20px;
`;

export const TextAreaField = styled.textarea`
	width: 100%;
	min-height: 100px;
	font-size: 16px;
	resize: vertical;
	padding: 8px;
	box-sizing: border-box;

	&:disabled {
		opacity: 0.7;
		cursor: not-allowed;
	}
`;

export const ErrorText = styled.span`
	color: ${Colors.red};
	font-size: 14px;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	margin-top: 20px;
	justify-content: center;
`;
